import React, { createContext, useContext } from 'react';
import { useSupervisorTeacherPicker } from '../hooks/useSupervisorTeacherPicker';

const defaultValue = {
  isSupervisorPicker: false,
  teachers: [],
  selectedTeacherId: null,
  selectedTeacherName: '',
  selectedTeacherTimezone: null,
  setSelectedTeacherId: () => {},
  teachersLoading: false,
  teachersError: false,
  ready: true,
};

const SupervisorTeacherContext = createContext(defaultValue);

export function SupervisorTeacherProvider({ children }) {
  const picker = useSupervisorTeacherPicker();
  return (
    <SupervisorTeacherContext.Provider value={picker}>{children}</SupervisorTeacherContext.Provider>
  );
}

export function useSupervisorTeacherContext() {
  return useContext(SupervisorTeacherContext);
}
